import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="header">
      <div className="container" style={{ position: 'relative' }}>
        {/* Small contact button in top right */}
        <a 
          href="mailto:pay2rule@gmail.com" 
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            fontSize: '12px',
            padding: '4px 8px',
            color: '#888',
            textDecoration: 'none',
            border: '1px solid #444',
            borderRadius: '0px',
            background: 'transparent'
          }}
        >
          Contact
        </a>

        <h1>PAY-2-WIN.COM</h1>
        <p className="header-subtitle">
        This leaderboard is determined by whoever paid the most money.
        That's it.
        Leave a cool art piece while you're at it.
        </p>
        <div className="header-buttons">
          <Link to="/create" className="btn btn-primary">
            Create Banner
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header; 